export default function GenerateIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_202_8425)">
        <path
          d="M3.00065 14.6667V11.3333M3.00065 4.66668V1.33334M1.33398 3.00001H4.66732M1.33398 13H4.66732M8.66732 2.00001L7.5112 5.00592C7.32319 5.49474 7.22919 5.73915 7.083 5.94473C6.95344 6.12694 6.79425 6.28614 6.61204 6.4157C6.40646 6.56188 6.16204 6.65588 5.67322 6.84389L2.66732 8.00001L5.67323 9.15613C6.16205 9.34414 6.40646 9.43814 6.61204 9.58432C6.79425 9.71388 6.95344 9.87308 7.083 10.0553C7.22919 10.2609 7.32319 10.5053 7.5112 10.9941L8.66732 14L9.82344 10.9941C10.0114 10.5053 10.1054 10.2609 10.2516 10.0553C10.3812 9.87308 10.5404 9.71388 10.7226 9.58432C10.9282 9.43814 11.1726 9.34414 11.6614 9.15613L14.6673 8.00001L11.6614 6.84389C11.1726 6.65588 10.9282 6.56188 10.7226 6.4157C10.5404 6.28614 10.3812 6.12694 10.2516 5.94473C10.1054 5.73915 10.0114 5.49474 9.82344 5.00592L8.66732 2.00001Z"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_202_8425">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "GenerateIcon";
